import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'ecp-auth-success',
  templateUrl: './auth-success.component.html',
  styleUrls: ['./auth-success.component.scss']
})
export class AuthSuccessComponent implements OnInit {

  public name: string;
  constructor(
    private msalAuthService: MsalService,
  ) { }

  ngOnInit(): void {
    this.msalAuthService.handleRedirectObservable().subscribe(res => {
      if (res) {
        this.name = res.account.idTokenClaims?.name || '';
      } else {
        const activeAccount = this.msalAuthService.instance.getActiveAccount();
        this.name = activeAccount?.idTokenClaims?.name || '';
      }
    });
  }
}
